import React from "react";
import ServiceRequestCloseImg from "../../../styles/img/service_close_icon.png";

export const ServiceRequestCloseIcon = () => {
  return (
    <>
      <img className="df-w-42" src={ServiceRequestCloseImg} />
    </>
  );
};
